import {TextInput as Global_TextInput} from "../../../components/custom-components/TextInput";
import {Colors} from "../colors";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {View} from "react-native";
import Text from "./Text";

function TextInput(props: any) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color)

    return <Global_TextInput {...props} style={[{
        color: Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color).get("highConText"),
        borderColor: colors.get("primaryColor") as string,
        borderRadius: 15,
        borderWidth: .5,
        fontFamily: "IRANsans",
        paddingHorizontal: 12,
        paddingVertical: 9,
    }, props.style]} />
}

export function TextInputLabeled(props:any){
    const color = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    return <View style={[{width: "100%"}, props.containerStyle]}>
        <Text weight={500} size={12} color={color.get("primaryColor") as string}>{props.label}</Text>
        <TextInput {...props}/>
    </View>
}
export default TextInput;